import {
  initialState,
  Actions,
  State,
  EDIT_COMPANY_BUSINESS_NAME,
  EDIT_COMPANY_BUSINESS_NAME_SUCCESS,
  EDIT_COMPANY_BUSINESS_NAME_ERROR,
  RESET_EDIT_COMPANY_BUSINESS_NAME,
} from '../../types/company/edit-business-name'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_COMPANY_BUSINESS_NAME:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_COMPANY_BUSINESS_NAME_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_COMPANY_BUSINESS_NAME_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_COMPANY_BUSINESS_NAME:
      return initialState
    default:
      return state
  }
}

export default reducers
